type StorageType = 'localStorage' | 'sessionStorage'

type ToObjectReturnType = Record<string, string | null>
interface ExtendedStorageApi extends Storage {
  toObject: () => ToObjectReturnType | null
}
export function createStorage(type: StorageType): ExtendedStorageApi {
  function storageAvailable() {
    let storage
    try {
      storage = window[type]
      const x = '__storage_test__'
      storage.setItem(x, x)
      storage.removeItem(x)
      return true
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      )
    }
  }

  return {
    getItem: (name: string) => {
      if (typeof window === 'undefined') return null
      if (!storageAvailable()) return null

      return window[type].getItem(name)
    },
    setItem: (name: string, value: string) => {
      if (typeof window === 'undefined') return
      if (!storageAvailable()) return

      window[type].setItem(name, value)
    },
    removeItem: (name: string) => {
      if (typeof window === 'undefined') return
      if (!storageAvailable()) return

      window[type].removeItem(name)
    },
    clear: () => {
      if (typeof window === 'undefined') return
      if (!storageAvailable()) return

      window[type].clear()
    },
    key: (index: number) => {
      if (typeof window === 'undefined') return null
      if (!storageAvailable()) return null

      return window[type].key(index)
    },
    toObject: () => {
      if (typeof window === 'undefined') return null
      if (!storageAvailable()) return null

      const result: ToObjectReturnType = {}
      for (let i = 0; i < window[type].length; i++) {
        const key = window[type].key(i)
        if (key) {
          result[key] = window[type].getItem(key)
        }
      }
      return result
    },
    length:
      typeof window !== 'undefined' && storageAvailable()
        ? window[type].length
        : 0,
  }
}

export const AppLocalStorage = createStorage('localStorage')
export const AppSessionStorage = createStorage('sessionStorage')
